<template>
    <div
        class="modal fade"
        id="talenttest-warn"
        tabindex="-1"
        role="dialog"
        aria-labelledby="talenttest-warn"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-md">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title" id="talenttest-warn-header">
                        Mange neutrale svar
                    </h2>
                    <button
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">
                            &times;
                        </span>
                    </button>
                </div>
                <div class="modal-body">
                    Vi kan se du har brugt knappen 'Spring over' mange gange. Desto flere gange du bruger knappen, desto usikre bliver resultatet. Prøv så godt du kan at vælge en af de to svarmuligheder.
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">
                        Ok
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TestWarn",
};
</script>
